export default "__VITE_ASSET__9b8b12d9__"